<h2 mat-dialog-title>Ingresos de {{ nombreUsuario }}</h2>
<mat-dialog-content>
  <mat-form-field>
    <mat-label>Filtro</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Filtro" #input />
  </mat-form-field>

  <div class="mat-elevation-z1 contenedorTabla" *ngIf="!isLoadingResults">
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="nombre">
        <th mat-header-cell *matHeaderCellDef>Nombre</th>
        <td mat-cell *matCellDef="let element">{{ element.nombre }}</td>
      </ng-container>

      <ng-container matColumnDef="disciplina">
        <th mat-header-cell *matHeaderCellDef>Disciplina</th>
        <td mat-cell *matCellDef="let element">{{ element.disciplina }}</td>
      </ng-container>

      <ng-container matColumnDef="fecha">
        <th mat-header-cell *matHeaderCellDef>Fecha</th>
        <td mat-cell *matCellDef="let element">{{ element.fecha | customDate }}</td>
      </ng-container>

      <ng-container matColumnDef="resultado">
        <th mat-header-cell *matHeaderCellDef>Resultado</th>
        <td mat-cell *matCellDef="let element">{{ element.resultado? 'Ingresó' : 'No ingresó' }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator
      #paginator
      [length]="length"
      [pageIndex]="pageIndex"
      [pageSize]="pageSize"
      [pageSizeOptions]="[10, 25, 100]"
      (page)="getServerData($event)"
    ></mat-paginator>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <!--  <button type="submit" mat-button mat-flat-button color="primary" (click)='guardar()' [disabled]="registerForm.invalid">Guardar</button> -->
  <button mat-button mat-dialog-close="false">Cerrar</button>
</mat-dialog-actions>
